import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { Description, MainHeadline } from 'components/Typography'
import { NavButton } from 'components/Button'

type Props = {
  backToTop: () => void
}

const NoteCompleteTemplate: FC<Props> = (props) => {
  const { backToTop } = props
  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'特定商取引法に関する記載'} />
      <Spacer size={16} />
      <Description description={'特定商取引法の登録が完了しました'} />
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} onClick={backToTop} url={''} />
      <Spacer size={72} />
    </div>
  )
}

export default NoteCompleteTemplate
